import { css } from '@emotion/css';

export const emotionStyles = {
  termsAndConditionsContainer: css({
    marginLeft: 15,
    marginTop: 20,
  }),
};
